export const dominikaChylinska = {
    'mydrId': 'dominikachylinska-mazurkiewicz',
    'firstName': 'Dominika',
    'lastName': 'Chylińska-Mazurkiewicz',
    'profession': 'Psychiatra',
    'avatar': 'dominika-chylinska.webp',
    'slug': 'dominika-chylinska-psychiatra',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult']
    ]
}